import { SEOHead } from "@/components/SEOHead";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";

const CancellationPolicy = () => {
  return (
    <div className="min-h-screen">
      <SEOHead
        title="Cancellation Policy | Son's Guadalupe"
        description="Review Son's Guadalupe cancellation and refund policy for cabana rentals, tubing, and glamping reservations on the Guadalupe River in New Braunfels, TX."
        canonical="/cancellation"
      />
      <Header />
      <main className="pt-32 pb-16">
        <div className="container-narrow mx-auto px-4 md:px-8">
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-charcoal mb-8">
            Cancellation Policy
          </h1>
          
          <div className="prose prose-lg max-w-none text-charcoal/80">
            <p className="text-lg mb-6">
              <strong>Last Updated:</strong> January 2025
            </p>

            <section className="mb-8">
              <h2 className="font-heading text-2xl font-bold text-charcoal mb-4">
                Standard Cancellation Policy
              </h2>
              <p className="mb-4">
                We understand that plans can change. Here is our cancellation policy:
              </p>
              
              <div className="bg-cream/50 rounded-xl p-6 mb-6">
                <h3 className="font-heading text-xl font-bold text-charcoal mb-3">
                  14+ Days Before Your Reservation
                </h3>
                <p className="text-charcoal/80">
                  Full refund minus a $25 processing fee per reservation.
                </p>
              </div>

              <div className="bg-cream/50 rounded-xl p-6 mb-6">
                <h3 className="font-heading text-xl font-bold text-charcoal mb-3">
                  7-13 Days Before Your Reservation
                </h3>
                <p className="text-charcoal/80">
                  50% refund of the total reservation amount.
                </p>
              </div>

              <div className="bg-cream/50 rounded-xl p-6 mb-6">
                <h3 className="font-heading text-xl font-bold text-charcoal mb-3">
                  Less Than 7 Days Before Your Reservation
                </h3>
                <p className="text-charcoal/80">
                  No refund available. Reservations are non-refundable within 7 days of your scheduled visit.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl font-bold text-charcoal mb-4">
                Weather-Related Cancellations
              </h2>
              <p className="mb-4">
                Your safety is our top priority. In the event of severe weather conditions that make it unsafe to operate:
              </p>
              <div className="bg-deep-green/10 rounded-xl p-6 mb-4">
                <p className="text-charcoal font-medium">
                  <strong>Full Refund:</strong> If Son's Guadalupe cancels your reservation due to severe weather (lightning, flash flooding, dangerous river conditions), you will receive a full refund.
                </p>
              </div>
              <p className="text-sm text-charcoal/60">
                Note: Light rain or overcast conditions do not qualify for weather-related cancellations. The river experience can be enjoyed in most weather conditions.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl font-bold text-charcoal mb-4">
                How to Request a Cancellation
              </h2>
              <p className="mb-4">
                To cancel your reservation, please contact us as soon as possible:
              </p>
              <ul className="list-none space-y-2 mb-4">
                <li><strong>Phone:</strong> 877-577-7667 (9am-7pm Daily)</li>
                <li><strong>Email:</strong> info@sonsguadalupe.com</li>
              </ul>
              <p className="text-charcoal/60">
                Please have your reservation confirmation number ready when contacting us.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl font-bold text-charcoal mb-4">
                Rescheduling
              </h2>
              <p className="mb-4">
                Need to change your date? We're happy to help reschedule your reservation based on availability. Rescheduling requests made 7+ days in advance can be accommodated without penalty, subject to availability.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl font-bold text-charcoal mb-4">
                No-Shows
              </h2>
              <p className="mb-4">
                Guests who do not arrive for their reservation without prior notice will not be eligible for a refund. If you're running late, please call us so we can accommodate you.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl font-bold text-charcoal mb-4">
                Questions?
              </h2>
              <p className="mb-4">
                If you have any questions about our cancellation policy, please don't hesitate to reach out. We're here to help make your Guadalupe experience as smooth as possible.
              </p>
              <ul className="list-none space-y-2">
                <li><strong>Phone:</strong> 877-577-7667</li>
                <li><strong>Email:</strong> info@sonsguadalupe.com</li>
              </ul>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CancellationPolicy;
